<!--
  ~ Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<footer class="">
    <div class="relative flex items-center justify-between px-3" style="min-height: 40px;">
        <!-- Left: GM Logo -->
        <span class="flex-none">GENERAL MOTORS</span>

        <!-- Center: Version info -->
        <span class="absolute-center text-center w-full pointer-events-none">
      eSCI Tools - {{ environmentName }} v{{ uiVersion }} (API v{{ apiVersion }})
    </span>

        <!-- Right: Copyright -->
        <span class="flex-none text-right">
      &copy; General Motors {{ currentYear }}. All Rights Reserved.
    </span>
    </div>
</footer>
